export default "__VITE_ASSET__BA0Ay7IB__"